import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router';
import { AuthProvider } from '@/context/AuthContext';
import { RepositoryProvider } from '@/context/RepositoryContext';
import { router } from '@/app/router';

function FallbackUI() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-900">
          Something went wrong
        </h1>
        <p className="mt-2 text-gray-600">
          An unexpected error occurred. Please refresh the page.
        </p>
        <button
          className="mt-4 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
          onClick={() => window.location.reload()}
        >
          Refresh
        </button>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <RepositoryProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </RepositoryProvider>
    </Sentry.ErrorBoundary>
  );
}
